import React, { Component } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Switch,
    Avatar,
    Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SettingsIcon from '@mui/icons-material/Settings';
import PixIcon from '@mui/icons-material/Pix';
import PaymentsIcon from '@mui/icons-material/Payments';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SaveIcon from '@mui/icons-material/Save';
import { toast } from 'react-toastify';
import PaymentProviderConfig from './PaymentProviderConfig';

class PaymentSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            methods: [
                { id: 'pix', label: 'PIX', icon: <PixIcon />, active: false },
                { id: 'money', label: 'Dinheiro', icon: <PaymentsIcon />, active: false },
                { id: 'credit', label: 'Cartão de Crédito', icon: <CreditCardIcon />, active: false },
                { id: 'debit', label: 'Cartão de Débito', icon: <CreditCardIcon />, active: false },
            ]
        };
    }

    componentDidMount() {
        // Verifica se a prop data existe para mapear os estados iniciais
        if (this.props.data) {
            const { id, ...paymentData } = this.props.data;

            this.setState((prevState) => ({
                id: id,
                methods: prevState.methods.map((method) => ({
                    ...method,
                    // Se o valor vindo da prop for 1, active vira true. Se for 0, vira false.
                    active: paymentData[method.id] === 1
                }))
            }));
        }
    }

    handleToggle = (id) => (event) => {
        event.stopPropagation(); // Impede o accordion de abrir ao clicar no switch
        this.setState((prevState) => ({
            methods: prevState.methods.map((method) =>
                method.id === id ? { ...method, active: !method.active } : method
            ),
        }));
    };

    handleSave = () => {
        // Monta o objeto de payload convertendo booleanos de volta para 0 ou 1
        const payload = {
            id: this.state.id
        };

        this.state.methods.forEach((method) => {
            payload[method.id] = method.active ? 1 : 0;
        });

        fetch(`${process.env.REACT_APP_API_URL}/settings`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                if (response.ok) {
                    toast.success('Configurações salvas com sucesso!');
                } else {
                    toast.error('Erro ao salvar configurações.');
                }
            })
            .catch((error) => {
                console.error('Erro ao salvar configurações:', error);
                toast.error('Erro ao salvar configurações.');
            });
    };

    render() {
        return (
            <Box sx={{ p: 0, margin: '0 auto', fontFamily: 'sans-serif', pb: 4 }}>
                {/* Título da Seção */}
                <Typography variant="h5" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Pagamentos
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                    Métodos e configurações
                </Typography>

                {/* Subheader com Link de Configuração */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                        Métodos Aceitos
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: 'text.secondary',
                            cursor: 'pointer',
                            '&:hover': { color: '#6200ee' }
                        }}
                    >
                        <SettingsIcon sx={{ fontSize: 18, mr: 0.5 }} />
                        <Typography variant="caption" sx={{ fontWeight: 500 }}>
                            Configure descontos por método
                        </Typography>
                    </Box>
                </Box>

                {/* Mapeamento dos Accordions */}
                {this.state.methods.map((method) => (
                    <Accordion
                        key={method.id}
                        disableGutters
                        elevation={0}
                        sx={{
                            mb: 1.5,
                            borderRadius: '12px !important',
                            border: '1px solid',
                            borderColor: method.active ? '#d1c4e9' : '#e0e0e0',
                            backgroundColor: method.active ? '#f5f0ff' : '#ffffff',
                            '&:before': { display: 'none' }, // Remove a linha separadora padrão do MUI
                            overflow: 'hidden'
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                '& .MuiAccordionSummary-content': { alignItems: 'center' },
                                px: 2
                            }}
                        >
                            <Avatar
                                sx={{
                                    bgcolor: method.active ? '#ede7f6' : '#f5f5f5',
                                    color: method.active ? '#6200ee' : '#9e9e9e',
                                    mr: 2,
                                    width: 42,
                                    height: 42,
                                    borderRadius: '10px'
                                }}
                            >
                                {method.icon}
                            </Avatar>

                            <Typography sx={{ flexGrow: 1, fontWeight: 500, color: '#333' }}>
                                {method.label}
                            </Typography>

                            <Switch
                                checked={method.active}
                                onChange={this.handleToggle(method.id)}
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#6200ee' },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#6200ee' }
                                }}
                            />
                        </AccordionSummary>

                        <AccordionDetails sx={{ bgcolor: '#fff', borderTop: '1px solid #f0f0f0' }}>
                            <Typography variant="body2" color="text.secondary">
                                Configurações adicionais para <strong>{method.label}</strong> podem ser adicionadas aqui, como taxas, prazos de compensação e chaves de integração.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
                <PaymentProviderConfig paymentData={this.props.data} />
                {/* Botão Salvar */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={this.handleSave}
                        sx={{
                            backgroundColor: '#6200ee',
                            textTransform: 'none',
                            borderRadius: '8px',
                            px: 3,
                            py: 1,
                            fontWeight: 600,
                            '&:hover': {
                                backgroundColor: '#4a00b5',
                            },
                        }}
                    >
                        Salvar Alterações
                    </Button>
                </Box>
            </Box>
        );
    }
}

export default PaymentSettings;